import React from "react";

const Java_While_Loop = () => {
  return (
    <div>
      <h1>Java While Loop</h1>
      <p>This page provides explanations, examples, and common use-cases for Java While Loop in Java.</p>
    </div>
  );
};

export default Java_While_Loop;
